import { Theme, createStyles } from '@material-ui/core/styles';

export const styles = (theme: Theme) =>
  createStyles({
    typography: {
      padding: theme.spacing(2),
    },
    card: {
      display: 'flex',
    },
    media: {
      height: 0,
      paddingTop: '56.25%', // 16:9
    },
    cover: {
      width: 150,
    },
    paper: {
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    root: {
      maxWidth: '400px',
      margin: 'auto',
      padding: theme.spacing(1),
    },
    schedule: {
      maxWidth: theme.spacing(170),
      margin: `0 auto`,
      padding: `0 ${theme.spacing(2)}px`,
    },
    rooms: {
      margin: theme.spacing(1),
      padding: `${theme.spacing(2)}px 0`,
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: theme.spacing(15),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    coursesGrid: {
      paddingTop: theme.spacing(2),
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    buttons: {
      '& > *': {
        flex: 1,
      },
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
    },
    studioCard: {},
    studioCover: {
      height: 0,
      paddingTop: '56.25%', // 16:9
    },
    bigAvatar: {
      width: 150,
      height: 150,
    },
    avatar: {},
  });

export default styles;
